import '../polyfills';
import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import thunk from 'redux-thunk'

// Import slices from new folder
import adminReducer from './slices/adminSlice'
import authReducer from './slices/authSlice'
import businessReducer from './slices/businessSlice'
import faqReducer from './slices/faqSlice'
import personalReducer from './slices/personalSlice'
import settingsReducer from './slices/settingsSlice'

if (typeof window !== 'undefined') {
  window.__REDUCER_TYPES__ = {
    auth: typeof authReducer,
    settings: typeof settingsReducer,
    admin: typeof adminReducer,
    business: typeof businessReducer,
    faq: typeof faqReducer,
    personal: typeof personalReducer
  };
  if (window.__LOGS__) {
    window.__LOGS__.push("REDUCER TYPES: " + JSON.stringify(window.__REDUCER_TYPES__));
  }
}

// Fix Redux DevTools Symbol.observable warning
// This must be done before any Redux imports to ensure compatibility
if (typeof Symbol !== 'undefined' && !Symbol.observable) {
  Object.defineProperty(Symbol, 'observable', {
    value: Symbol('observable'),
    writable: false,
    enumerable: false,
    configurable: false
  })
}

// Additional fix for Redux DevTools compatibility
if (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) {
  // Ensure Symbol.observable is properly defined before Redux is imported
  if (!Symbol.observable) {
    Object.defineProperty(Symbol, 'observable', {
      value: Symbol('observable'),
      writable: false,
      enumerable: false,
      configurable: false
    })
  }
}



const safeAuthReducer = (state, action) => {
  if (typeof authReducer === 'function') {
    return authReducer(state, action)
  }
  return state !== undefined ? state : { currentUser: null, isAuthenticated: false }
}

const safeSettingsReducer = (state, action) => {
  if (typeof settingsReducer === 'function') {
    return settingsReducer(state, action)
  }
  return state !== undefined ? state : {}
}

const safePersonalReducer = (state, action) => {
  if (typeof personalReducer === 'function') {
    return personalReducer(state, action)
  }
  return state !== undefined ? state : {}
}

const safeBusinessReducer = (state, action) => {
  if (typeof businessReducer === 'function') {
    return businessReducer(state, action)
  }
  return state !== undefined ? state : {}
}

const safeAdminReducer = (state, action) => {
  if (typeof adminReducer === 'function') {
    return adminReducer(state, action)
  }
  return state !== undefined ? state : {}
}

const safeFaqReducer = (state, action) => {
  if (typeof faqReducer === 'function') {
    return faqReducer(state, action)
  }
  return state !== undefined ? state : {}
}

// Combine reducers using the new slices
const appReducer = combineReducers({
  auth: safeAuthReducer,
  personal: safePersonalReducer,
  business: safeBusinessReducer,
  faq: safeFaqReducer,
  // parse: parseReducer, // Removed - functionality moved to AuthSlice
  admin: safeAdminReducer,
  settings: safeSettingsReducer
})


const rootReducer = (state, action) => {
  if (action.type === 'auth/logoutUser') {
    // Keep settings, reset the rest to avoid data cross-contamination
    const { settings } = state || {};
    state = { settings };
  }
  return appReducer(state, action);
}

// Create store using Redux Toolkit configureStore
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(thunk),
  devTools: typeof window !== 'undefined' && !!window.__REDUX_DEVTOOLS_EXTENSION__
})

export default store
